module.exports = __webpack_public_path__ + "img/LenovoImage.3e51f406.jpg";